
import React from 'react';
import PageActions from '@/components/ui/PageActions';
import { FilterOption } from '@/components/ui/FilterDropdown';

interface ContactsActionsProps {
  filterOptions: FilterOption[];
  onFilterChange: (updatedOptions: FilterOption[]) => void;
  onAddContact?: () => void;
}

/**
 * ContactsActions component displays the search and filter options
 */
const ContactsActions: React.FC<ContactsActionsProps> = ({
  filterOptions,
  onFilterChange,
}) => {
  return (
    <PageActions
      filterOptions={{
        options: filterOptions,
        onFilterChange: onFilterChange,
        label: "Industries"
      }}
    />
  );
};

export default ContactsActions;
